import { inject, type InjectionKey } from 'vue';

/** Re-mounts the active <router-view> (forces a fresh fetch). Provided by AppLayout. */
export const RELOAD_VIEW: InjectionKey<() => void> = Symbol('reloadView');

/** Consumer helper — no-op when used outside the app layout. */
export function useReloadView(): () => void {
  return inject(RELOAD_VIEW, () => {});
}
